import { useMemo } from 'react'

import styles from './styles.module.scss'

import errorIcon from '@/assets/icons/toast-error.svg?url'
import progressIcon from '@/assets/icons/toast-progress.svg?url'
import successIcon from '@/assets/icons/toast-success.svg?url'

export interface ToastProps {
  message: string
  type: 'success' | 'error' | 'progress'
  animationClass: string
}

const Toast = (props: ToastProps) => {
  const { message, type, animationClass } = props

  const icon = useMemo(() => {
    switch (type) {
      case 'success':
        return successIcon
      case 'error':
        return errorIcon
      case 'progress':
        return progressIcon
    }
  }, [type])

  return (
    <div className={`${styles.toast} ${animationClass}`}>
      <img src={icon} alt={`${type} icon`} className={`${styles.icon} ${type === 'progress' ? styles.spin : ''}`} />
      <p>{message}</p>
    </div>
  )
}

export default Toast
